var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.bookGoodsModel.noShare)?_c('img',{directives:[{name:"track",rawName:"v-track",value:({
    name: '分享',
    id: '199e7841-2be4-4d77-b997-5894f123ff76',
  }),expression:"{\n    name: '分享',\n    id: '199e7841-2be4-4d77-b997-5894f123ff76',\n  }"}],class:_vm._.icon,attrs:{"src":require('./images/分享.png')},on:{"click":_vm.handleShareClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }